var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMagic = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "magic_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#magic_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "m30.818 15.364-1.932-4.25-4.25-1.932 4.25-1.932L30.818 3l1.932 4.25L37 9.182l-4.25 1.932-1.932 4.25Zm0 21.636-1.932-4.25-4.25-1.932 4.25-1.932 1.932-4.25 1.932 4.25L37 30.818l-4.25 1.932L30.818 37Zm-15.454-4.636-3.864-8.5L3 20l8.5-3.864 3.864-8.5 3.863 8.5 8.5 3.864-8.5 3.864-3.863 8.5Zm0-7.496 1.545-3.322L20.232 20l-3.323-1.546-1.545-3.322-1.546 3.322L10.496 20l3.322 1.546 1.546 3.322Z"
}))));
export default SvgMagic;